export const DisclaimerAcceptanceInstore: string[] = [
  "To accept DinersClub, UnionPay and JCB, the PSP must be linked to Bambora Global Acquiring. All Worldline's terminals are connected to Bambora Global Acquiring.",
  "Acquiring prices stated in contract cover both purchase and refund transactions",
];
